// Normalizes server error responses into { formError, fieldErrors }.
//
// The v2 API returns either:
//   - 400 validation: a field-keyed object, e.g. { email: 'email is required' }
//   - 401 login:      { loginError: 'Invalid credentials' }
//   - a plain string message
// Keys that aren't per-field (loginError) bubble up as a form-level error.

const NON_FIELD_KEYS = new Set(['loginError', 'error', 'message']);

export function parseApiError(err) {
  const data = err?.response?.data;
  const result = { formError: null, fieldErrors: {} };

  if (data == null) {
    result.formError = err?.message || 'Something went wrong. Please try again.';
    return result;
  }

  if (typeof data === 'string') {
    result.formError = data;
    return result;
  }

  if (typeof data === 'object') {
    for (const [key, val] of Object.entries(data)) {
      const text = typeof val === 'string' ? val : JSON.stringify(val);
      if (NON_FIELD_KEYS.has(key)) {
        result.formError = text;
      } else {
        result.fieldErrors[key] = text;
      }
    }
  }

  if (!result.formError && Object.keys(result.fieldErrors).length === 0) {
    result.formError = 'Something went wrong. Please try again.';
  }

  return result;
}
